import styled from '@src/styled-components';

export const ContainerCircle = styled.span`
width: 50px;
height: 50px;
border-radius: 50%;
background-color: #F3F6FC;
border: 2px solid #6A8CA5;
display: flex;
align-items: center;
justify-content: center;
`

export const ModalContainer = styled.div`
    margin: 0 10%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .ant-steps-item-title{
        padding-right: 0;
        transform: translateY(8px);
    }
`

export const ItemDiv = styled.span`
    display: flex;
    align-items: center;
    flex-direction: column;
    p{
        font-size: 0.8em;
    }   
`

export const OptionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    font-family: "Montserrat";
    color: #8493AA;
    margin-left: 10%;
    .repeat-container{
        margin: 3% 0;
        width: 100%;
        .ant-radio-group-solid{
            width: 100%;
        }
        .ant-radio-group{
            width: 100%;
        }
        .ant-radio-button-wrapper{
            width: 20%;
            border: 1px solid #B5B5B5;
            color: #335D7C;
            font-weight: 600;
            text-align: center;
        }
        .ant-radio-button-wrapper-checked{
            background-color: #D9EBF9;
            border: 1px solid #B5B5B5;
            color: #335D7C;
            font-weight: 600;
            box-shadow: none;
        }
        .ant-radio-button-wrapper:hover{
            background-color: #D9EBF9;
            border: 1px solid #B5B5B5;
            color: #335D7C;
        }
    }
    .select-time-container{
        padding: 20px 0 20px 0;
    }
        .time-input{
            width: 80px;
            text-align: center;
            letter-spacing: 0.3em;
            color: #595959;
            font-weight: 500;
            border-radius: 5px;
            border: 1px solid #B5B5B5;
        }
    }

    .select-process{
        margin-bottom: 20px;
        .ant-select-selection{
            width: 20em;
        }
    }

    .options-buttons{
        display: flex;
        justify-content: flex-end;

        button{
            margin: 0 20px;
            text-transform: uppercase;
            font-weight: 700;
        }
        button:hover{
            cursor: pointer;
        }

        .no-bg{
            background: none;
            border: none;
            color: #335D7C;
            font-weight: 700;
        }
        .pill-button{
            border-radius: 50px;
            border: none;
            min-width: 100px;
            width: 20%;
            height: 30px;
            background: #335D7C;
            color: #FFFFFF;
            letter-spacing: 0.1em;
            font-weight: 600;
            :disabled{
                background-color: gray;
                cursor: default;
            }
        }
    }

    .user-group-container{
        .user-group-select{
            .ant-select-selection{
                width: 30vw;
            }
        }
        .margin-top{
            margin-top: 10%;
        }
    }
    .desc-container{
        padding: 0 20px 20px 0;
        font-size: 1.25em;
        font-weight: 500;
    }

    .title-container{
        margin-bottom: 5%;
        .title-input{
            border-radius: 5px;
            border: 1px solid #d9d9d9;
            padding: 5px;
            height: 90%;
            color: #595959;
        }
    }

    .required-label{
        display: flex;
        .text-label{
            margin-left: 10px;
            background-color: #7CA2BE;
            color: white;
            border-radius: 50px;
            margin-top: 8px;
            font-weight: 500;
            transform: translateY(-40%);
            letter-spacing: 0.1em;
            font-size: 0.6em;
            p{
                padding: 0px 10px;
                transform: translateY(40%);
            }
        }

`

export const CalendarContainer = styled.div`
    .rbc-row-content {
        z-index: 2;
    }

    .rbc-day-bg:hover{
        cursor: pointer;
        background-color: #eaf6ff;
    }

    .rbc-event {
        &.is-overdue {
            background-color: #CE6767;
        }

        &.pendent {
            background-color: #DDD057;
        }

        &.in-progress {
            background-color: #AFAFAF;
        }

        &.done {
            background-color: #0DA854;
        }
    }
`

export const CalendarFilters = styled.div`
    display: block;
    margin-bottom: 25px;
    .ant-checkbox-wrapper {
        border: 1px solid #000000;
        padding: 5px 10px;
        border-radius: 5px;
        background-color: lightgrey;
        font-size: 14px;
        &.pendent {
            background-color: #FFFEF1;
            border-color: #C7B831;
            color: #C7B831;
            .ant-checkbox-inner {
                background-color: #FFF7B4;
                border-color: #C7B831;
            }
            &.ant-checkbox-wrapper-checked {
                .ant-checkbox-inner {
                    background-color: #C7B831;
                }
            }
        }

        &.done {
            background-color: #E3FFF0;
            border-color: #0DA854;
            color: #0DA854;
            .ant-checkbox-inner {
                background-color: #8BFFC1;
                border-color: #0DA854;
            }
            &.ant-checkbox-wrapper-checked {
                .ant-checkbox-inner {
                    background-color: #0DA854;
                }
            }
        }

        &.in-progress {
            background-color: #F4F4F4;
            border-color: #697478;
            color: #697478;
            .ant-checkbox-inner {
                background-color: #D1D1D1;
                border-color: #697478;
            }
            &.ant-checkbox-wrapper-checked {
                .ant-checkbox-inner {
                    background-color: #697478;
                }
            }
        }

        &.overdue {
            background-color: #FFF1F1;
            border-color: #D93838;
            color: #D93838;
            .ant-checkbox-inner {
                background-color: #FFBABA;
                border-color: #D93838;
            }
            &.ant-checkbox-wrapper-checked {
                .ant-checkbox-inner {
                    background-color: #D93838;
                }
            }
        }
    }
    .ant-checkbox-checked::after {
        border-color: transparent;
    }
`;
